<template>
  <div id="ScanMenu" class="has-text-centered">
    <!-- <dashboard :uppy="uppy" :plugins="['ImageEditor']"/> -->
    <div v-if="uploadedUrl !==''" id="drag-drop-area"></div>
    <!-- <div id="uppy-transloadit-result">
      <input type="text" class="input" v-model="uploadedUrl" /></div>

    <button class="button" @click="runOcr()">OCR</button> -->
    <div v-else-if="isLoading"><button class="button full-width" :class="{'is-loading':isLoading}"></button></div>
    <div id="lines"  v-if="lines.length > 0">
      <div class="columns is-gapless is-multiline is-mobile" v-for="line, i in lines" :key="i">
        <div class="column is-1 is-narrow is-text-centered" >
          <b-select v-model="lines[i].itemType">
                <option
                    value="item"
                    key="item">
                   item
                </option>
                <option
                    value="Header"
                    key="Header">
                   Header
                </option>
            </b-select>
        </div>
        <div class="column is-6" >
        <input class="input" :class="{'has-text-weight-bold': lines[i].itemType == 'Header'}" type="text" v-model="lines[i].itemName" >
        </div>
        <div class="column is-2" >
        <input class="input" type="text" v-model="lines[i].itemDesc" >
        </div>
        <div class="column is-1" >
        <input class="input" type="text" v-model="lines[i].itemPriceComment" >
        </div>
        <div class="column is-1" >
        <input class="input" type="text" v-model="lines[i].itemPrice" >
        </div>
        
        <div class="column is-1 " >
          <svg @click="deleteLine(i)" style="cursor:pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
          <svg @click="addOptions(lines[i])" style="cursor:pointer; stroke: white;fill: blue;" xmlns="http://www.w3.org/2000/svg" viewBox="-4 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="icon__icon"><path d="M8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM7 5.83a3.001 3.001 0 1 1 2.033-.013v2.028c0 .074-.003.148-.008.221a1 1 0 0 0 .462.637l3.086 1.846a3 3 0 0 1 1.46 2.575v1.059a3.001 3.001 0 1 1-2-.024v-1.035a1 1 0 0 0-.487-.858L8.46 10.42a3 3 0 0 1-.444-.324 3 3 0 0 1-.443.324l-3.086 1.846a1 1 0 0 0-.487.858v1.047a3.001 3.001 0 1 1-2 0v-1.047a3 3 0 0 1 1.46-2.575l3.086-1.846a1 1 0 0 0 .462-.637A3.006 3.006 0 0 1 7 7.845V5.829zM3 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path></svg>
        </div>
        <div class="modifications column is-12"  v-if="lines[i].modifications">
          <div class="columns">
        <div class="column is-1" >        </div>
          <div class="column is-3" v-if="lines[i].modifiers[0].mods[0]">
            <input class="input" type="text" v-model="lines[i].modifiers[0].mods[0].name" >
            <input class="input" type="number" v-model.number="lines[i].modifiers[0].mods[0].price" >
          </div>
          <div class="column is-3" v-if="lines[i].modifiers[0].mods[1]">
            <input class="input" type="text" v-model="lines[i].modifiers[0].mods[1].name" >
            <input class="input" type="number" v-model.number="lines[i].modifiers[0].mods[1].price" >
          </div>
          <div class="column is-3" v-if="lines[i].modifiers[0].mods[2]">
            <input class="input" type="text" v-model="lines[i].modifiers[0].mods[2].name" >
            <input class="input" type="number" v-model.number="lines[i].modifiers[0].mods[2].price" >
          </div>
          <div class="column is-3" v-if="lines[i].modifiers[0].mods[3]">
            <input class="input" type="text" v-model="lines[i].modifiers[0].mods[3].name" >
            <input class="input" type="number" v-model.number="lines[i].modifiers[0].mods[3].price" >
          </div>
        <div class="column is-1" ></div>
          </div>
        </div>
      </div>
    <button @click="addToMenu()" class="button is-success mt-4 mb-4">Add to Menu</button>
    <button @click="replaceMenu()" class="button is-success mt-4 mb-4">Replace Menu</button>
    <button @click="nameToUpper()" class="button mt-4 mb-4">Upper Case</button>
    <button @click="nameToProper()" class="button mt-4 mb-4">Proper Case</button>

    <div class="columns">
        <div class="column is-1" >        </div>
          <div class="column is-3">
            <input class="input" type="text" v-model="options[0]" >
          </div>
          <div class="column is-3">
            <input class="input" type="text" v-model="options[1]" >
          </div>
          <div class="column is-3">
            <input class="input" type="text" v-model="options[2]" >
         </div>
          <div class="column is-3">
            <input class="input" type="text" v-model="options[3]" >
         </div>
        <div class="column is-1" ></div>
          </div>
    </div>
  </div>
  
</template>

<script>
import Uppy from '@uppy/core'
const dashboard = require('@uppy/dashboard')
const ImageEditor = require('@uppy/image-editor')
const Transloadit = require('@uppy/transloadit')

import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import '@uppy/image-editor/dist/style.css'

import _ from "underscore";
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'ScanMenu',
  components: {
    // Dashboard,
    // ImageEditor
  },
  data() {
    return {
      // uploadedUrl: "https://tmp-ap-southeast-1.transloadit.net/3f58f0ac67f74f478f5552625ef4747e.jpg",
      uploadedUrl: "https://tmp-ap-southeast-1.transloadit.net/3f58f0ac67f74f478f5552625ef4747e.jpg",
      lines: [],
      isLoading: false,
      options: []
    }
  },
  computed:  _.extend(
  {
    uppy: () => new Uppy({
      autoProceed: false,
      restrictions: {
        maxFileSize: 1024 * 1024 * 1024,
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        // allowedFileTypes: ['image/*', 'pdf']
      },
    })
  },
    mapGetters({
    place: "getPlaceInfo"
  })
),
  mounted() {
    this.lines = this.place.menu

    this.uppy.use(dashboard, {
      inline: true,
      target: '#drag-drop-area'
    })
    this.uppy.use(ImageEditor, {
        id: 'ImageEditor',
        target: dashboard,
        quality: 0.8,
        cropperOptions: {
          viewMode: 1,
          background: false,
          autoCropArea: 1,
          responsive: true
        },
        actions: {
          revert: true,
          rotate: true,
          flip: true,
          zoomIn: true,
          zoomOut: true,
          cropSquare: true,
          cropWidescreen: true,
          cropWidescreenVertical: true
        }
      })
      .use(Transloadit, {
        params: {
          auth: {
            key: "b41acd71b6e64332b41fb6e27adf7643"
          },
          steps: {
            "optimized": {
              "use": ":original",
              "robot": "/image/optimize",
              "result": true
            }
          }
        },
        waitForEncoding: true
      })
    this.uppy.on('file-added', (file) => {
      console.log('Added file', file)
    })
    this.uppy.on('complete', result => {
      console.log('successful files:', result.successful)
      // this.uploadedUrl = result.successful[0].uploadURL
      // console.log(this.uploadedUrl);
      
      //   this.runOcr();
      // console.log('failed files:', result.failed)
    })
    this.uppy.on('file-editor:start', (file) => {
        console.log("Editor started")
      })
      .on('transloadit:result', (stepName, result) => {
        console.log("uploaded", result);

        this.uploadedUrl = result.ssl_url
        this.runOcr();
      })
  },
  beforeDestroy() {
    this.uppy.close()
  },
  methods: _.extend({}, mapActions(["updatePlaceInfo"]), {
    runOcr() {
      this.isLoading = true
      var axios = require('axios');
      var FormData = require('form-data');
      var data = new FormData();
      data.append('language', 'eng');
      data.append('isTable', 'true');
      data.append('OCREngine', 2);
      data.append('isOverlayRequired', 'false');
      data.append('url', this.uploadedUrl);
      data.append('iscreatesearchablepdf', 'false');
      data.append('issearchablepdfhidetextlayer', 'false');
      // data.append('filetype', 'PDF');

      var config = {
        method: 'post',
        url: 'https://api.ocr.space/parse/image',
        headers: {
          'apikey': '258340647388957',
        },
        data: data
      };
    console.log(data);
    
      axios(config)
        .then((response) => {
          console.log(response.data);
          // this.lines = response.data.ParsedResults[0].TextOverlay.Lines
          let text = response.data.ParsedResults[0].ParsedText
          var lines = text.split(/\n/);
          var output = [];
          for (var i = 0; i < lines.length; i++) {
            // only push this line if it contains a non whitespace character.
            if (/\S/.test(lines[i])) {
              output.push({
                image : 0,
                itemOrder : i,
                itemName: lines[i].split(/\t/)[0].trim(),
                itemDesc: "",
                itemId : generateRowId(4),
                itemPriceComment: "",
                itemPrice: parseInt(lines[i].split(/\t/)[1]) || "",
                itemType: "item"
              });
            }
          }
          console.log("OCR", output);
          this.lines.concat(output)
          for (let k = 0; k<output.length; k++) {
            output[k].itemOrder = this.lines.length
            this.lines.push(output[k])
          }
          this.isLoading = false
        })
        .catch(function (error) {
          this.isLoading = false
          console.log(error);
        });
    },
    replaceMenu() {
      
      for (let i =0; i<this.lines.length; i++) {
        this.lines[i].image = 0
        this.lines[i].itemOrder = i
        this.lines[i].itemId = generateRowId(4)
        this.lines[i].itemPrice = parseInt(this.lines[i].itemPrice) || ""
        if (this.lines[i].modifiers)
            for (let j=0; j < this.lines[i].modifiers[0].mods.length; j++)
              if (!this.lines[i].modifiers[0].mods[j].price || this.lines[i].modifiers[0].mods[j].price == "") {
                console.log('Removing', this.lines[i].modifiers[0].mods[j]);
                
                this.lines[i].modifiers[0].mods.splice(j,1)
              }
      }
      this.place.menu = this.lines;
      this.updatePlaceInfo(this.place).then(() => {
        this.place.canPublish = true;
        this.$buefy.toast.open(this.$t('DashboardTable.saved'))
      });
    },
    addToMenu() {
       for (let i =0; i<this.lines.length; i++) {
         if (this.lines[i].modifiers)
            for (let j=0; j < this.lines[i].modifiers[0].mods.length; j++)
              if (!this.lines[i].modifiers[0].mods[j].price || this.lines[i].modifiers[0].mods[j].price == "") {
                console.log('Removing', this.lines[i].modifiers[0].mods[j]);
                
                this.lines[i].modifiers[0].mods.splice(j,1)
              }
         this.place.menu.push(this.lines[i])
       }
      this.updatePlaceInfo(this.place).then(() => {
        this.$buefy.toast.open(this.$t('DashboardTable.saved'))
      });
    },
    deleteLine(i) {
      this.lines.splice(i,1)
    },
    nameToUpper() {
      for (let i =0; i<this.lines.length; i++) {
        this.lines[i].itemName = this.lines[i].itemName.toUpperCase();
      } 
    },
    nameToProper() {
      for (let i =0; i<this.lines.length; i++) {
        this.lines[i].itemName = toTitleCase(this.lines[i].itemName);
      } 
    },
    addOptions(item) {
      if (item.modifications) {
        item.modifications = false;
        item.hasModifiers = false;
        return
      }
      // if (!item.modifiers)
      let mods = []
      for (let i=0; i<this.options.length; i++)
        mods.push({
          name: this.options[0]
        })
      this.$set(item, "modifiers", [
        {"name":"Options",
        "id":1,
        "min_selection":1,
        "max_selection":1,
        "select_type":"radio",
        "mods": [{
          name: this.options[0],
          price: item.itemPrice
        }, {
          name: this.options[1]
        }, 
        {
          name: this.options[2]
        },
        {
          name: this.options[3]
        }
        ]
        }
      ]
      )
      this.$set(item, "modifications", true)
      this.$set(item, "hasModifiers", true)
      console.log(item);
      
    }
  }
  )
}

function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}

function generateRowId(subid) {
        var EPOCH = 1300000000000;
        var ts = new Date().getTime() - EPOCH; // limit to recent
        var randid = Math.floor(Math.random() * 512);
        ts = ts * 64; // bit-shift << 6
        ts = ts + subid;
        return "a" + ts * 512 + (randid % 512);
      }
</script>

<style>
.uppy-Dashboard-inner {
	margin-left: auto;
	margin-right: auto;
}
.modifications {
	margin-bottom: 15px !important;
	margin-top: 5px !important;
}
.columns.is-gapless.is-multiline.is-mobile {
	margin-bottom: 0;
}
</style>